const enumList = undefined
const storeBase = undefined
const userBase = undefined
const selectAddress = undefined
const shoppingCarNum = 0
const shoppingCarSaveNum = -1
const systemBase = undefined
const activityData = {
  isEnable: false
}
const diveCenterList = undefined
const diveCourseList = undefined
const moneyExchangeList = undefined

const aidaConfigList = undefined
export default
{
  enumList,
  storeBase,
  userBase,
  selectAddress,
  shoppingCarNum,
  shoppingCarSaveNum,
  systemBase,
  activityData,
  diveCenterList,
  diveCourseList,
  moneyExchangeList,
  aidaConfigList
}
